import { Modal } from '@/components/common/AppModal';
import { Button, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type DeleteApiKeyModalProps = {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
};

const DeleteApiKeyModal = ({
  show,
  onHide,
  onConfirm,
  isDeleting
}: DeleteApiKeyModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title> حذف API Key</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="danger" className="mb-3 fs--1">
          <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
          <strong>هشدار:</strong> پس از حذف API Key، دیگر قادر به استفاده از API
          نخواهید بود.
        </Alert>
        <p className="mb-0">آیا از حذف API Key مطمئن هستید؟</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          انصراف
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              در حال حذف...
            </>
          ) : (
            'بله، حذف کن'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteApiKeyModal;
